<template>
	<CardGeneric class="border-ternary bg-ternary bg-opacity-10">
		<slot></slot>
	</CardGeneric>
</template>

<script setup></script>

<style lang="scss" scoped></style>
